import * as SearchCriteriasStyle from "../../../styles/events/search-criterias.module.scss";
import * as popUpStyles from "../../../styles/layout/search-pop-up.module.scss";

import IconContainer from "../IconContainer";
import React from "react";
import {useTranslation} from "react-i18next";

const Search = React.memo(function Search({
    getSearchWords, height, padding, italic, placeholder, initalSearch,
}) {
    const [searchWord, setSearchWord] = React.useState(initalSearch || "");
    const {t} = useTranslation();

    function updateSearchValue(value) {
        setSearchWord(value);
        getSearchWords(value);
    }

    function getFocus() {
        if (typeof window !== `undefined`) {
            if (document.querySelector("input[name='search']")) {
                document.querySelector("input[name='search']").focus();
            }
        }
    }

    return (<div className={SearchCriteriasStyle.searchContainer}>
        <div
            className={popUpStyles.search}
            style={height || padding ? {height: height, padding: padding} : {}}
        >
            <div className={popUpStyles.inputContainer}>
                <div className={popUpStyles.searchIconItem}>
                    <IconContainer icon="SEARCH" color="BLACK" size={25}/>
                </div>
                <div className={popUpStyles.inputItem}>
                    <input
                        name='search'
                        title={placeholder || t("search.bar")}
                        aria-label={t("search.window.search")}
                        className={popUpStyles.input}
                        value={searchWord}
                        onChange={(event) => updateSearchValue(event.target.value)}
                        placeholder={placeholder || t("search.bar")}
                        style={italic ? {
                            fontSize: 15, fontWeight: 500, fontStyle: "italic", outline: 0, width: "90%",
                        } : {outline: 0, width: "90%"}}
                    />
                </div>
            </div>
            <button className={popUpStyles.closeContainer}>
                <IconContainer
                    notHidden={true} label={t("search.clear")}
                    icon="MENU_CLOSE"
                    color="BLACK"
                    aria-label={t("search.window.close")}
                    size={10}
                    onClick={() => {
                        updateSearchValue("");
                        getFocus()
                    }}
                    onKeyDown={() => {
                        updateSearchValue("");
                        getFocus()
                    }}
                    tabIndex="0"
                />
            </button>
        </div>
    </div>);
});

export default Search;
